// SB INSTAGRAM
(() => {
  document.addEventListener("DOMContentLoaded", () => {
    let _domSbIntagramImages = document.querySelector("#sbi_images");

    if (!_domSbIntagramImages) {
      return;
    }

    // Add container slide
    window.requestAnimationFrame(() => {
      _domSbIntagramImages.innerHTML = `
            <div class="slide">
                ${_domSbIntagramImages.innerHTML}
            </div>
            <button type="button" class="btn_voltar hidden">
                Voltar imagens
                <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.17824 -1.3013e-07C9.49101 -1.53638e-08 10.169 1.56418 9.22959 2.483L3.58987 8L9.22959 13.517C9.81032 14.085 9.81032 15.006 9.22959 15.574C8.64894 16.142 7.70744 16.142 7.1268 15.574L0.435635 9.02854C-0.145102 8.46054 -0.145102 7.53954 0.435635 6.97154L7.1268 0.426088C7.41712 0.141998 7.79768 -1.63399e-07 8.17824 -1.3013e-07Z" fill="#7D275C"/>
                </svg>
            </button>
            <button type="button" class="btn_avancar">
                Avançar imagens
                <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.90328 19.3334C0.371718 19.3334 -0.419218 17.5085 0.676707 16.4366L7.25638 10.0001L0.676707 3.56358C-0.000819023 2.90091 -0.000819023 1.82641 0.676707 1.16375C1.35413 0.501081 2.45254 0.501081 3.12996 1.16375L10.9363 8.80011C11.6138 9.46278 11.6138 10.5373 10.9363 11.1999L3.12996 18.8363C2.79125 19.1678 2.34727 19.3334 1.90328 19.3334Z" fill="#7D275C"/>
                </svg>
            </button>
        `;

      _domSbIntagramImages = document.querySelector("#sbi_images");

      window.requestAnimationFrame(() => {
        const _domSlide = _domSbIntagramImages.querySelector(".slide");
        const _domBtnVoltar = _domSbIntagramImages.querySelector(".btn_voltar");
        const _domBtnAvancar = _domSbIntagramImages.querySelector(
          ".btn_avancar"
        );

        const _largura = _domSbIntagramImages.offsetWidth;
        const _quantidadeElementos =
          _domSlide.querySelectorAll(".sbi_item").length / 2;
        const _larguraElemento = 248;
        const _elementosVisiveis = parseFloat(
          (_largura / _larguraElemento).toFixed(1)
        );

        const _quantidadeItensAvancar = 3;
        const _limiteLeftVoltar = 0;
        const _limiteLeftAvancar =
          (parseFloat((_elementosVisiveis - _quantidadeElementos).toFixed(1)) -
            0.15) *
          _larguraElemento;

        _domBtnVoltar.addEventListener("click", () => {
          const __leftTemp =
            parseInt(_domSlide.style.left || 0) +
            _larguraElemento * _quantidadeItensAvancar;
          const __left =
            __leftTemp >= _limiteLeftVoltar ? _limiteLeftVoltar : __leftTemp;

          _domSlide.style.left = `${__left}px`;

          window.requestAnimationFrame(() => {
            if (__left == _limiteLeftVoltar) {
              _domBtnVoltar.classList.add("hidden");
              _domBtnAvancar.classList.remove("hidden");
            } else {
              _domBtnVoltar.classList.remove("hidden");
              _domBtnAvancar.classList.remove("hidden");
            }
          });
        });

        _domBtnAvancar.addEventListener("click", () => {
          const __leftTemp =
            parseInt(_domSlide.style.left || 0) -
            _larguraElemento * _quantidadeItensAvancar;
          const __left =
            __leftTemp <= _limiteLeftAvancar ? _limiteLeftAvancar : __leftTemp;

          _domSlide.style.left = `${__left}px`;

          window.requestAnimationFrame(() => {
            if (__left == _limiteLeftAvancar) {
              _domBtnAvancar.classList.add("hidden");
              _domBtnVoltar.classList.remove("hidden");
            } else {
              _domBtnAvancar.classList.remove("hidden");
              _domBtnVoltar.classList.remove("hidden");
            }
          });
        });
      });
    });
  });
})();
